// useEvent.js
import useFetch from "./useFetch.js";
import API_BASE_URL from "../../config/config.js";
import axios from "axios";

export const useEvent = (idevent) =>
  useFetch(
    (signal) =>
      axios.get(`${API_BASE_URL}/championship/?idevent=${idevent}`, { signal }),
    [idevent]
  );
